/** `data-app-id` da renovação 2026 — prefixo `renewal-` (mesmo padrão de `contractAppIds.ts`). */
export const RENEWAL_APP_IDS = {
  screen: 'renewal-screen',
  loading: 'renewal-loading',
  loadError: 'renewal-load-error',
  loadErrorSupport: 'renewal-load-error-support',
  supportDrawer: 'renewal-support-drawer',
  stepIdentify: 'renewal-step-identify',
  stepVerify: 'renewal-step-verify',
  contractSummary: 'renewal-contract-summary',
  channelSelector: 'renewal-channel',
  sendCode: 'renewal-send-code',
  identifySupport: 'renewal-identify-support',
  codeSentBanner: 'renewal-code-sent',
  changeContact: 'renewal-change-contact',
  codeInput: 'renewal-code',
  resendCode: 'renewal-resend-code',
  switchChannel: 'renewal-switch-channel',
  verifyCode: 'renewal-verify-code',
  stepReview: 'renewal-step-review',
  personalCard: 'renewal-personal-card',
  addressCard: 'renewal-address-card',
  equipmentCard: 'renewal-equipment-card',
  quoteError: 'renewal-quote-error',
  offer: 'renewal-offer',
  coverages: 'renewal-coverages',
  upsell: 'renewal-upsell',
  summary: 'renewal-summary',
  stepPayment: 'renewal-step-payment',
  paymentMethod: 'renewal-payment-method',
  newCard: 'renewal-new-card',
  paymentSummary: 'renewal-payment-summary',
  processing: 'renewal-processing',
  stepPhotos: 'renewal-step-photos',
  photosLoadError: 'renewal-photos-load-error',
  sendPhotos: 'renewal-send-photos',
  outcome: 'renewal-outcome'
} as const;
